import Vue from 'vue'
import Vuex from 'vuex'
import { getCurrencyList } from "../api/common"

Vue.use(Vuex)

const state = {
  userInfo: {},
  loading: false,
  selectPage: 0,
  selectProductTab: 0,
  currencyList: [],
  pageTabs: [],
  currentTabKey: "",
}

// 修改 state
const mutations = {
  setUserInfo(state, data) {
    state.userInfo = data
  },
  setLoading(state, data) {
    state.loading = data
  },
  setCurrencyList(state, data) {
    state.currencyList = data
  },
  setPageTabs(state, data) {
    state.pageTabs = data
  },
  setCurrentTabKey(state, data) {
    state.currentTabKey = data
  },
  removePageTab(state, key) {
    const index = state.pageTabs.findIndex(item => item.path === key);
    if (index >= 0) {
      state.pageTabs.splice(index, 1);
    }
  }
}

// 获取 state
const getters = {
  userInfo(state) {
    return state.userInfo
  },
  getLoading: (state) => {
    return state.loading
  },
  getCurrencyList: (state) => {
    return state.currencyList
  },
  getCurrencyMap: (state) => {
    const values = state.currencyList || [];
    const obj = {};
    for (const item of values) {
      obj[item.value] = item;
    }
    return obj;
  },
  getPageTabs: (state) => {
    return state.pageTabs
  },
  getCurrentTabKey: (state) => {
    return state.currentTabKey
  }
}

export default new Vuex.Store({
  state: state,
  mutations,
  actions: {
    async initCurrencyList(context) {
      let list = [
        {
          value: "CNY",
          label: "人民币",
          symbol: "￥",
          quotient: "4.69%"
        },
        {
          value: "USD",
          label: "美元",
          symbol: "$",
          quotient: "49.7%"
        },
        {
          value: "VND",
          label: "越南盾",
          symbol: "₫",
          quotient: ""
        }
      ]
      try {
        const result = await getCurrencyList();
        if (result.success) {
          list = result.data
        }
      } catch (error) {
        console.log(error, 'error')
      }
      context.commit("setCurrencyList", list);
    },
  },
  getters
})
